import { tss } from 'tss-react/mui';

const useStyles = tss
  .withParams<{
    container?: boolean;
  }>()
  .create(({ theme, container }) => ({
    openTimer: {
      alignItems: 'flex-start',
      display: 'flex',
      fontWeight: 700
    },
    openTimerIcon: {
      color: 'var(--mui-palette-text-disabled)',
      lineHeight: '2.25rem',
      marginRight: theme.spacing(1)
    },
    openTimerDuration: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column'
    },
    openTimerDurationTime: {
      color: theme.vars.palette.text.primary,
      fontSize: container ? '10cqi' : '1.75rem',
      lineHeight: container ? '10cqi' : '2rem'
    },
    openTimerDurationText: {
      color: theme.vars.palette.text.secondary,
      fontSize: container ? '3.5cqi' : '0.6rem',
      lineHeight: container ? '3.5cqi' : ''
    },
    openTimerTimeColon: {
      color: theme.vars.palette.text.primary,
      fontSize: container ? '10cqi' : '2rem',
      lineHeight: container ? '6cqi' : '1rem',
      padding: theme.spacing(0.75, 0.5)
    }
  }));

export default useStyles;
